import { getJson } from './baseApi'

export const fetchDocumentRuleSets = () => {
	return getJson('/api/verification/docscan/rule-sets')
}
